import { useEffect, useRef, useState } from "react";

export default function FieldOptionsContainer({ component, onPropertyChange }) {
    // console.log("FieldOptionsContainer component", component.properties && component.properties.find(a => a.property === "Options"));
    const _properties = component.properties ? Array.isArray(component.properties) ? component.properties : [] : [];
    const [options, setOptions] = useState((_properties && _properties.find(a => a.property === "Options") && JSON.parse(_properties.find(a => a.property === "Options")?.values)) || []);
    // const [options, setOptions] = useState([]);
    const [defaultValue, setDefaultValue] = useState("");
    const [dragIndex, setDragIndex] = useState(null);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        onPropertyChange(JSON.stringify(options));
        console.log("FieldOptionsContainer Options", options);
        // Optionally call onPropertyChange here if needed
    }, [options, defaultValue, dragIndex]);

    const handleAdd = () => {
        setOptions([
            ...options,
            {
                option: "",
                labels: [
                    { text: "", weight: 0, inherit: true }
                ],
                weight: 0,
                alert: false,
            },
        ]);
    };

    const handleEdit = (idx, field, val) => {
        const newOptions = [...options];
        newOptions[idx][field] = val;
        setOptions(newOptions);
    };

    const handleRemove = (idx) => {
        setOptions(options.filter((_, i) => i !== idx));
        if (defaultValue === options[idx].option) setDefaultValue("");
    };

    const handleSetDefault = (val) => {
        setDefaultValue(val);
    };

    const handleDragStart = (idx) => setDragIndex(idx);
    const handleDrop = (idx) => {
        if (dragIndex === null || dragIndex === idx) return;
        const newOptions = [...options];
        const [dragged] = newOptions.splice(dragIndex, 1);
        newOptions.splice(idx, 0, dragged);
        setOptions(newOptions);
        setDragIndex(null);
    };

    // Label handlers
    const handleLabelEdit = (optIdx, labelIdx, field, val) => {
        const newOptions = [...options];
        newOptions[optIdx].Labels[labelIdx][field] = val;
        setOptions(newOptions);
    };
    const handleAddLabel = (optIdx) => {
        let newOptions = [...options];
        if (!newOptions) newOptions = [];
        if (!newOptions[optIdx].Labels) newOptions[optIdx].Labels = [];
        newOptions[optIdx].Labels.push({ text: "", weight: 0, inherit: true });
        setOptions(newOptions);
    };
    const handleRemoveLabel = (optIdx, labelIdx) => {
        const newOptions = [...options];
        newOptions[optIdx].Labels = newOptions[optIdx].Labels.filter((_, i) => i !== labelIdx);
        setOptions(newOptions);
    };

    // Collect all unique label texts except current
    const getLabelSuggestions = (optIdx, labelIdx) => {
        const texts = [];
        options.forEach((opt, oIdx) => {
            opt.Labels && opt.Labels.forEach((label, lIdx) => {
                if (!(oIdx === optIdx && lIdx === labelIdx) && (typeof label.text === 'string' && label.text.trim())) {
                    texts.push(label.text.trim());
                }
            });
        });
        return Array.from(new Set(texts));
    };

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center m-2">
                <div>
                    <h3>Options</h3>
                    <p className="text-muted">Define the options for this field. You can add labels to each option for more granularity.</p>
                </div>
                <button className="btn btn-xs btn btn-xs-primary" onClick={handleAdd}>Add Option</button>
            </div>
            <ul style={{ listStyle: "none", padding: 0 }}>
                {options.map((opt, idx) => (
                    <li
                        key={idx}
                        draggable
                        onDragStart={() => handleDragStart(idx)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(idx)}
                        style={{
                            borderBottom: "1px solid #ccc",
                            margin: "8px 0",
                            padding: "8px",
                            background: defaultValue === opt.option ? "#FFE7E7FF" : "transparent",
                        }}
                    >
                        <div className="d-flex align-items-center">
                            <div>
                                <label>Option</label>
                                <input
                                    type="text"
                                    placeholder="Option"
                                    className="form-control form-control-sm"
                                    value={opt.option}
                                    onChange={(e) => handleEdit(idx, "option", e.target.value)}
                                    style={{ marginRight: 8 }}
                                />
                                <p className="text-muted small" style={{ marginBottom: 0 }}>
                                    This is the option text that will be displayed in the questionnaire as well as on reports.
                                </p>
                            </div>
                            <div>
                                <label>Weight</label>
                                <input
                                    type="number"
                                    placeholder="Main Weight"
                                    className="form-control form-control-sm"
                                    value={opt.weight}
                                    onChange={(e) => handleEdit(idx, "weight", Number(e.target.value))}
                                    style={{ width: 80, marginRight: 8 }}
                                />
                                <p className="text-muted small" style={{ marginBottom: 0 }}>
                                    This is the main weight for the option.
                                </p>
                            </div>
                            <div>
                                <label className="text-center" style={{ marginRight: 8 }}>

                                    <div>
                                        Alert when selected
                                    </div>
                                    <input
                                        type="checkbox"
                                        checked={opt.alert}
                                        onChange={(e) => handleEdit(idx, "alert", e.target.checked)}
                                    />
                                </label>
                                <p className="text-muted small" style={{ marginBottom: 0 }}>
                                    This option will trigger an alert when selected in the questionnaire.
                                </p>
                            </div>
                            <button className="btn btn-xs" onClick={() => handleRemove(idx)} style={{ marginRight: 8 }}>
                                Remove
                            </button>
                        </div>
                        {/* <button
                            onClick={() => handleSetDefault(opt.value)}
                            disabled={defaultValue === opt.value}
                        >
                            {defaultValue === opt.value ? "Default" : "Set Default"}
                        </button> */}
                        <div style={{ marginTop: 8, marginLeft: 16 }}>
                            <strong>Labels:</strong>
                            <ul style={{ listStyle: "none", padding: 0 }}>
                                {opt.Labels && opt.Labels.map((label, lIdx) => {
                                    const datalistId = `label-suggestions-${idx}-${lIdx}`;
                                    const suggestions = getLabelSuggestions(idx, lIdx);
                                    return (
                                        <li key={lIdx} style={{ marginBottom: 4 }} className="d-flex">
                                            <input
                                                type="text"
                                                placeholder="Label text"
                                                className="form-control form-control-sm w-25"
                                                value={label.text}
                                                onChange={e => handleLabelEdit(idx, lIdx, "text", e.target.value)}
                                                style={{ marginRight: 8 }}
                                                list={datalistId}
                                            />
                                            <datalist id={datalistId}>
                                                {suggestions.map((s, i) => (
                                                    <option key={i} value={s} />
                                                ))}
                                            </datalist>
                                            <label style={{ marginRight: 8 }}>
                                                <input
                                                    type="checkbox"
                                                    checked={label.inherit}
                                                    onChange={e => handleLabelEdit(idx, lIdx, "inherit", e.target.checked)}
                                                />
                                                Inherit main weight
                                            </label>
                                            <input
                                                type="number"
                                                placeholder="Label weight"
                                                className="form-control form-control-sm"
                                                value={label.inherit ? opt.weight : label.weight}
                                                disabled={label.inherit}
                                                onChange={e => handleLabelEdit(idx, lIdx, "weight", Number(e.target.value))}
                                                style={{ width: 70, marginRight: 8 }}
                                            />
                                            <button className="btn btn-xs" onClick={() => handleRemoveLabel(idx, lIdx)}>
                                                Remove Label
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                            <button className="btn btn-xs" onClick={() => handleAddLabel(idx)}>Add Label</button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
